/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetProjectsStatus200, GetProjectsStatus401 } from '../types/GetProjects'
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query'
import { getProjects } from '../clients/getProjects'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

export const getProjectsSuspenseQueryKey = () => [{ url: '/projects/' }] as const

type GetProjectsSuspenseQueryKey = ReturnType<typeof getProjectsSuspenseQueryKey>

export function getProjectsSuspenseQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getProjectsSuspenseQueryKey()
  return queryOptions<GetProjectsStatus200, ResponseErrorConfig<GetProjectsStatus401>, GetProjectsStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getProjects({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /projects/}
 */
export function useGetProjectsSuspense<TData = GetProjectsStatus200, TQueryKey extends QueryKey = GetProjectsSuspenseQueryKey>(options: {
  query?: Partial<UseSuspenseQueryOptions<GetProjectsStatus200, ResponseErrorConfig<GetProjectsStatus401>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getProjectsSuspenseQueryKey()

  const queryResult = useSuspenseQuery({
   ...getProjectsSuspenseQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetProjectsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
